/**
 * @generated SignedSource<<9eec6b3131e5c408a63f56c2aa07fd25>>
 * @relayHash 69f9e77fb5ae45cfd6ec96b0809c46c6
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dcdd9a7cd47e269fc77723823a02f55fc2d086d9bb3b124257c16c3c37e76cea

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EventHostStatus = "CONFIRMED" | "DECLINED" | "PENDING" | "%future added value";
export type DeclineEventHostInvitationInput = {
  clientMutationId?: string | null | undefined;
  pEventHostId?: string | null | undefined;
};
export type EventHostInvitationBannerDeclineMutation$variables = {
  input: DeclineEventHostInvitationInput;
};
export type EventHostInvitationBannerDeclineMutation$data = {
  readonly declineEventHostInvitation: {
    readonly eventHost: {
      readonly id: string;
      readonly status: EventHostStatus;
    } | null | undefined;
  } | null | undefined;
};
export type EventHostInvitationBannerDeclineMutation = {
  response: EventHostInvitationBannerDeclineMutation$data;
  variables: EventHostInvitationBannerDeclineMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeclineEventHostInvitationPayload",
    "kind": "LinkedField",
    "name": "declineEventHostInvitation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EventHost",
        "kind": "LinkedField",
        "name": "eventHost",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventHostInvitationBannerDeclineMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventHostInvitationBannerDeclineMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "dcdd9a7cd47e269fc77723823a02f55fc2d086d9bb3b124257c16c3c37e76cea",
    "metadata": {},
    "name": "EventHostInvitationBannerDeclineMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "66fdac005bda9e164f4a647420580124";

export default node;
